import { render, staticRenderFns } from "./_join_deny_user_modal.vue?vue&type=template&id=3860345e&"
import script from "./_join_deny_user_modal.vue?vue&type=script&lang=js&"
export * from "./_join_deny_user_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports